var map = {
	"./bfs/app/shared/auth-nav-menu/user-menu/user-menu.component": [
		55738,
		"src_themes_bfs_app_shared_auth-nav-menu_user-menu_user-menu_component_ts"
	],
	"./custom/app/shared/auth-nav-menu/user-menu/user-menu.component": [
		95208,
		"src_themes_custom_app_shared_auth-nav-menu_user-menu_user-menu_component_ts"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 13361;
module.exports = webpackAsyncContext;